/**
 * 商户结算统计
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>档案中心</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="服务商 :">
        <el-input
          size="small"
          v-model="formInline.disCompanyName"
          placeholder="请输入服务商"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">搜索</el-button>
        <el-button size="small" @click="reset()">清空</el-button>
      </el-form-item>
    </el-form>

    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column
        fixed
        prop="agentName"
        label="代理商"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        fixed
        prop="distributeCompanyName"
        label="服务商"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="agentFeeRate"
        label="代理费率"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ formatRate(scope.row.agentFeeRate) }}</span>
        </template></el-table-column
      >
      <el-table-column label="合同" show-overflow-tooltip>
        <template #default="scope">
          <span
            v-if="scope.row.contract && scope.row.contractStatus === 3"
            style="color: #409eff; cursor: pointer"
            @click="onViewContract(scope.row)"
          >
            查看
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="contractStatus"
        label="签约状态"
        show-overflow-tooltip
        :formatter="formatContractStatus"
      ></el-table-column>
      <el-table-column
        prop="contractSignAtStr"
        label="签约时间"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
  </div>
</template>

<script>
import { getAgentRate } from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载

      contractStatusList: [
        {
          label: "未签约",
          value: 0,
        },
        {
          label: "签约中",
          value: 1,
        },
        {
          label: "拒签",
          value: 2,
        },
        {
          label: "归档",
          value: 3,
        },
      ],

      // rules表单验证
      rules: {},
      formInline: {
        page: 1,
        pageSize: 10,
        disCompanyName: "",
      },

      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    reset() {
      this.formInline = {
        page: 1,
        pageSize: 10,
        disCompanyName: "",
      };
      this.getdata(this.formInline);
    },
    // 获取公司列表
    getdata(formInline) {
      let params = {
        page: formInline.page,
        pageSize: formInline.pageSize,
        disCompanyName: formInline.disCompanyName,
      };
      getAgentRate(params)
        .then((res) => {
          if (res.msg == "success") {
            this.listData = res.data.items;
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {});
    },
    onViewContract(row) {
      if (!row.contract) {
        this.$message.error("合同正在生成上传中，请稍后重试");
        return;
      }
      window.open(row.contract);
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    formatRate(rate) {
      if (rate != null && rate !== undefined) {
        return `${(parseFloat(rate) * 100).toFixed(2)}%`;
      }
      return ""; // 或者根据你的需求返回其他默认值
    },
    formatContractStatus(row, column, cellValue) {
      if (cellValue == 0 && row.contractNumber) {
        return "签署中";
      }
      const status = this.contractStatusList.find(
        (status) => status.value === cellValue
      );
      return status ? status.label : cellValue;
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.userRole {
  width: 100%;
}
</style>

 


// WEBPACK FOOTER //
// src/views/agent/agentRate.vue